import { createFileRoute } from "@tanstack/react-router";
import { StaticInfoPage } from "@/components/static-info-page";
import { CONTACT_CHANNEL, CONTACT_EMAIL_SUFFIX } from "@/lib/business-info";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Điều Khoản Dịch Vụ - Quy Định Sử Dụng" },
      {
        name: "description",
        content:
          "Điều khoản sử dụng dịch vụ Bói Đê: phạm vi dịch vụ, trách nhiệm tài khoản, thanh toán và quy định thay đổi. Tìm hiểu ngay!",
      },
      { property: "og:title", content: "Điều Khoản Dịch Vụ - Quy Định Sử Dụng" },
      {
        property: "og:description",
        content: "Các điều khoản quy định cách truy cập và sử dụng nền tảng huyền học Bói Đê.",
      },
      { property: "og:url", content: "https://boide.online/terms" },
    ],
    links: [{ rel: "canonical", href: "https://boide.online/terms" }],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <StaticInfoPage
      kicker="TERMS OF SERVICE"
      title="Điều khoản dịch vụ"
      description="Các điều khoản này quy định cách người dùng truy cập và sử dụng nền tảng Bói Đê. Khi sử dụng dịch vụ, bạn đồng ý tuân thủ các nội dung dưới đây. Cập nhật lần cuối: 27/07/2026."
      sections={[
        {
          title: "1. Phạm vi và tính chất dịch vụ",
          paragraphs: [
            "Bói Đê cung cấp trải nghiệm tham khảo về Kinh Dịch, Tử Vi, Bát Tự và các nội dung phân tích, luận giải được tạo bởi trí tuệ nhân tạo (AI), bao gồm cả tính năng trò chuyện bằng văn bản và giọng nói.",
            "Toàn bộ nội dung trên nền tảng chỉ mang tính chất tham khảo, chiêm nghiệm văn hóa; không phải lời khuyên và không thay thế tư vấn pháp lý, tài chính, y tế, tâm lý hoặc quyết định chuyên môn khác.",
            "Nghiêm cấm sử dụng dịch vụ cho mục đích cờ bạc, lô đề, cá cược hoặc bất kỳ hoạt động nào vi phạm pháp luật Việt Nam. Bói Đê không cung cấp và từ chối trả lời các nội dung dạng này.",
          ],
        },
        {
          title: "2. Điều kiện sử dụng",
          paragraphs: [
            "Bạn cần đủ 18 tuổi để đăng ký tài khoản và sử dụng các dịch vụ có trả phí. Người chưa đủ 18 tuổi chỉ nên sử dụng dưới sự đồng ý và giám sát của cha mẹ hoặc người giám hộ.",
            "Bạn cam kết cung cấp thông tin đúng khi đăng ký và khi thực hiện các giao dịch trên nền tảng.",
          ],
        },
        {
          title: "3. Tài khoản người dùng",
          paragraphs: [
            "Bạn chịu trách nhiệm bảo mật thông tin đăng nhập và mọi hoạt động phát sinh từ tài khoản của mình.",
            "Bạn không được sử dụng dịch vụ cho mục đích gian lận, lạm dụng chương trình khuyến mãi, tạo nhiều tài khoản ảo, tấn công hệ thống, phát tán nội dung vi phạm pháp luật hoặc xâm phạm quyền của bên thứ ba.",
          ],
        },
        {
          title: "4. Nạp tiền và số dư — không hoàn lại",
          paragraphs: [
            "Khi nạp tiền, số tiền được quy đổi thành số dư trong tài khoản Bói Đê để sử dụng các dịch vụ trên nền tảng. Số dư này KHÔNG được hoàn lại, không được rút ra tiền mặt, không quy đổi ngược thành tiền và không chuyển nhượng cho tài khoản khác, dưới bất kỳ hình thức nào — kể cả khi bạn ngừng sử dụng dịch vụ hoặc tài khoản bị khóa do vi phạm điều khoản.",
            "Vui lòng cân nhắc kỹ số tiền trước khi nạp. Việc thực hiện giao dịch nạp tiền đồng nghĩa bạn đã đọc, hiểu và đồng ý với chính sách không hoàn tiền này.",
            `Ngoại lệ duy nhất: nếu giao dịch chuyển khoản thành công nhưng số dư chưa được cộng do lỗi hệ thống, hoặc một lượt dịch vụ bị trừ phí nhưng không trả kết quả do lỗi từ phía Bói Đê, chúng tôi sẽ kiểm tra và cộng bù vào số dư tài khoản (không hoàn bằng tiền mặt). Liên hệ qua ${CONTACT_CHANNEL} kèm mã giao dịch để được hỗ trợ.`,
          ],
        },
        {
          title: "5. Khuyến mãi, thưởng và mã quà tặng",
          paragraphs: [
            "Các khoản thưởng như điểm danh hằng ngày, quà từ hộp thư, thưởng nạp, mã quà tặng (giftcode), ưu đãi giới thiệu là ưu đãi do Bói Đê cấp, không có giá trị quy đổi thành tiền mặt và có thể được điều chỉnh, tạm ngưng hoặc kết thúc mà không cần báo trước.",
            "Bói Đê có quyền thu hồi các khoản thưởng và khóa tài khoản nếu phát hiện hành vi lạm dụng, gian lận (ví dụ: tạo nhiều tài khoản để nhận thưởng, tự giới thiệu chính mình).",
          ],
        },
        {
          title: "6. Giá dịch vụ",
          paragraphs: [
            "Các dịch vụ được tính phí theo lượt sử dụng (luận giải lá số, xem theo chủ đề), theo lượng nội dung trao đổi (trò chuyện với thầy) hoặc theo thời gian (Bói Live tính theo giây). Mức phí được hiển thị trước khi bạn sử dụng hoặc trong bảng giá của từng tính năng.",
            "Bói Đê có thể điều chỉnh giá dịch vụ theo từng thời điểm. Mức giá áp dụng là mức hiển thị tại thời điểm bạn sử dụng dịch vụ; các lượt đã sử dụng trước đó không bị ảnh hưởng.",
          ],
        },
        {
          title: "7. Chương trình giới thiệu và hoa hồng",
          paragraphs: [
            "Số dư hoa hồng từ chương trình giới thiệu là khoản tách biệt với số dư bói: có thể quy đổi sang số dư bói hoặc yêu cầu rút về tài khoản ngân hàng khi đạt mức tối thiểu, theo quy định của chương trình tại từng thời điểm.",
            "Bói Đê có quyền từ chối chi trả và thu hồi hoa hồng phát sinh từ hành vi gian lận (tài khoản ảo, tự giới thiệu, thao túng giao dịch). Quy tắc chi tiết được công bố tại trang Hướng dẫn hoa hồng và có thể được điều chỉnh theo thời gian.",
          ],
        },
        {
          title: "8. Nội dung người dùng và chia sẻ công khai",
          paragraphs: [
            "Khi bạn chủ động tạo liên kết chia sẻ quẻ hoặc lá số, gửi cảm nhận, hoặc bật hồ sơ se duyên, nội dung đó có thể hiển thị công khai hoặc với người dùng khác theo phạm vi bạn đã chọn. Bạn chịu trách nhiệm về nội dung mình cung cấp và có thể thu hồi liên kết chia sẻ bất cứ lúc nào.",
            "Bạn cho phép Bói Đê hiển thị các nội dung này trong phạm vi vận hành dịch vụ. Bói Đê có quyền gỡ nội dung vi phạm pháp luật, thuần phong mỹ tục hoặc xâm phạm quyền của người khác.",
          ],
        },
        {
          title: "9. Tính năng kết nối người dùng (se duyên, hợp tác)",
          paragraphs: [
            "Các tính năng kết nối chỉ là công cụ gợi ý dựa trên phân tích tương hợp mang tính tham khảo. Bói Đê không xác minh danh tính người dùng và không chịu trách nhiệm về các tương tác, giao dịch hoặc quan hệ phát sinh giữa những người dùng, dù trên hay ngoài nền tảng.",
            "Hãy cẩn trọng khi chia sẻ thông tin cá nhân (số điện thoại, email, địa chỉ) với người dùng khác; bạn toàn quyền chọn từng trường thông tin muốn chia sẻ sau khi kết nối.",
          ],
        },
        {
          title: "10. Nội dung AI và giới hạn trách nhiệm",
          paragraphs: [
            "Nội dung luận giải do AI tạo ra có thể không chính xác, không đầy đủ hoặc không phù hợp với hoàn cảnh riêng của bạn. Bạn tự chịu trách nhiệm với mọi quyết định đưa ra dựa trên nội dung của nền tảng.",
            "Trong phạm vi pháp luật cho phép, Bói Đê không chịu trách nhiệm cho các thiệt hại gián tiếp phát sinh từ việc sử dụng dịch vụ. Dịch vụ có thể tạm gián đoạn để bảo trì, nâng cấp hoặc do sự cố ngoài tầm kiểm soát.",
          ],
        },
        {
          title: "11. Sở hữu trí tuệ",
          paragraphs: [
            "Thương hiệu, giao diện, mã nguồn, hệ thống nhân vật thầy bói và nội dung do Bói Đê xây dựng thuộc quyền sở hữu của Bói Đê. Không sao chép, khai thác lại cho mục đích thương mại khi chưa có sự đồng ý bằng văn bản.",
            "Bạn được sử dụng kết quả luận giải cho mục đích cá nhân, bao gồm chia sẻ qua các tính năng có sẵn của nền tảng.",
          ],
        },
        {
          title: "12. Tạm ngưng và chấm dứt tài khoản",
          paragraphs: [
            "Bói Đê có quyền cảnh báo, tạm khóa hoặc chấm dứt tài khoản vi phạm điều khoản, gian lận hoặc gây hại cho hệ thống và người dùng khác.",
            "Trường hợp tài khoản bị chấm dứt do vi phạm, số dư và các khoản thưởng còn lại không được hoàn trả theo chính sách tại mục 4 và 5.",
          ],
        },
        {
          title: "13. Thay đổi điều khoản",
          paragraphs: [
            "Bói Đê có thể cập nhật điều khoản để phù hợp với thay đổi sản phẩm, quy định vận hành hoặc yêu cầu pháp luật.",
            "Phiên bản cập nhật có hiệu lực khi được công bố trên website. Việc tiếp tục sử dụng dịch vụ sau thời điểm công bố đồng nghĩa bạn chấp nhận điều khoản mới.",
          ],
        },
        {
          title: "14. Luật áp dụng và liên hệ",
          paragraphs: [
            "Điều khoản này được điều chỉnh theo pháp luật Việt Nam. Tranh chấp phát sinh sẽ được ưu tiên giải quyết thông qua thương lượng; nếu không đạt được thỏa thuận, tranh chấp được đưa ra tòa án có thẩm quyền tại Việt Nam.",
            `Mọi thắc mắc về điều khoản, giao dịch hoặc khiếu nại vui lòng gửi qua mục Hộp thư trong ứng dụng${CONTACT_EMAIL_SUFFIX}.`,
          ],
        },
      ]}
    />
  );
}
